import { RootState } from 'types';

export const siteListSelector = (state: RootState) => state.siteListContainer;
